import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageWithIcon } from '../common/messagePopup';
import { addDriverUser } from '../../services/drivers';
import { getSupervisors } from '../../services/supervisors';
import { TOKEN, USER_TYPE, USER_ID } from '../../api/axios';

const AddDriver = () => {
  const navigate = useNavigate();

  const [saveUserParams, setSaveUserParams] = useState({
    username: '',
    phone: '',
    emp_code: '',
    email: '',
    password: '',
  });

  const [supervisors, setSupervisors] = useState([]);
  const [selSupervisor, setSelSupervisor] = useState(0);
  const [selUserId, setselUserId] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const currentUser = sessionStorage.getItem(USER_TYPE);
    const isAdminUser = currentUser.toLowerCase() === 'admin';
    setIsAdmin(isAdminUser);
    const userId = sessionStorage.getItem(USER_ID);
    setselUserId(userId);
    if (isAdminUser) {
      fetchSupervisors(isAdminUser, userId);
    } else {
      setSelSupervisor(userId);
    }
  }, []);

  const fetchSupervisors = async (isAdminUser, userId) => {
    // Example
    try {
      const res = await getSupervisors();
      let options = [{ id: 0, user: { username: 'Select', id: 0 } }];
      res.forEach(spv => {
        if (isAdminUser || userId === spv.user.id) {
          options.push(spv);
        }
      });
      setSupervisors(options);
      setSelSupervisor(options[0].user.id);
    } catch (err) {
      console.error(err);
      setSupervisors([]); // fallback to avoid undefined
    }
  };
  const handleInputChange = e => {
    setSaveUserParams({ ...saveUserParams, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (selSupervisor === 0) {
      MessageWithIcon('Select a supervisor', 'error');
      return;
    }
    const input = {
      supervisor_id: parseInt(selSupervisor),
      email: saveUserParams.email,
      username: saveUserParams.username,
      phone: saveUserParams.phone,
      password: saveUserParams.password,
      employee_code: saveUserParams.emp_code,
    };

    addDriverUser(input)
      .then(response => {
        try {
          if (response?.account) {
            MessageWithIcon('User Created! ' + response.message, 'success');
            navigate('/driver/list');
          }
        } catch (err) {
          MessageWithIcon(`Add Driver Error: ${err}`, 'error');
        }
      })
      .catch(err => {
        MessageWithIcon(err.data.error, 'error');
      });
  };

  return (
    <div className="content container">
      <div className="page-header">
        <div className="page-title">
          <h4>Driver Management</h4>
          <h6>Add/Update Driver</h6>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row">
            {isAdmin && (
              <div className="col-md-3">
                <label>Supervisor</label>
                <select
                  className="form-select"
                  value={selSupervisor}
                  onChange={e => setSelSupervisor(e.target.value)}
                >
                  {supervisors.map(s => (
                    <option key={s.user.id} value={s.user.id}>
                      {s.user.username}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="col-md-3">
              <label>Employee Code</label>
              <input
                type="text"
                name="emp_code"
                className="form-control"
                value={saveUserParams.emp_code}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label>Username</label>
              <input
                type="text"
                name="username"
                className="form-control"
                value={saveUserParams.username}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={saveUserParams.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                className="form-control"
                value={saveUserParams.phone}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label>Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={saveUserParams.password}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-12 mt-3">
              <button className="btn btn-primary me-2" onClick={handleSubmit}>
                Submit
              </button>
              <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDriver;
